module.exports = __webpack_public_path__ + "img/project-cover4.9412a985.png";